import { Button, Result } from 'antd';
import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class AdminErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[后台页面渲染失败]', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="admin-error-page">
        <Result
          status="error"
          title="页面加载失败"
          subTitle="可能是后台刚刚更新或网络暂时中断，请重新加载后继续。"
          extra={<Button type="primary" onClick={() => window.location.reload()}>重新加载后台</Button>}
        />
      </div>
    );
  }
}
